import { ComponentType } from '@angular/cdk/portal'
import { Notification } from '@notifications/models/notifications'

export const notificationComponentMap: Record<string, () => Promise<ComponentType<unknown>>> = {
  image: () => import('../modals/image-modal/image-modal.component').then(m => m.ImageModalComponent),
  video: () => import('../modals/video-modal/video-modal.component').then(m => m.VideoModalComponent),
  encuesta_fachada: () => import('../modals/encuesta-fachada/encuesta-fachada.component').then(m => m.EncuestaFachadaComponent),
  encuesta_comunicaciones_abastecimiento: () => import('../modals/encuesta-comunicaciones-abastecimiento/encuesta-comunicaciones-abastecimiento.component').then(m => m.EncuestaComunicacionesAbastecimientoComponent),
  encuesta_camara_fria: () => import('../modals/camara-fria/camara-fria.component').then(m => m.CamaraFriaComponent),
  coca_cola: () => import('../modals/coca-cola/coca_cola.component').then(m => m.CocaColaComponent),
  encuesta_mundial_bees: () => import('../modals/encuesta-mundial-bees/encuesta-mundial-bees.component').then(m => m.EncuestaMundialBeesComponent)
}

export const getModalComponent = async (notification: Notification) => {
  const { category, type } = notification

  const loadComponent = notificationComponentMap[category] || notificationComponentMap[type!]
  if (loadComponent) return await loadComponent()

  return
}
